export default __webpack_public_path__ + "static/mobile-worker-25e054587fdc0d97d39eac5233d4f334.png";